const Green = {
    title: 'Green',
    background: 'radial-gradient(circle, #92bf86 0%, #5a804f 100%)',
    colors: {
        primary: '#60a64c',
        secondary: '#a1de90',
        terciary: '#98c78b',
        fourth: '#ebf7e1',
        fifth: '#f7fcf2'
    }
};

export default Green;